/**
 * Takes a full URL and removes the protocol + paths to make it look "clean".
 * The use-case is when displaying a link with a long URL as the text, we
 * want it to be easier to read and then show the full URL only on hover.
 *
 * @param {string} url - The full URL to shorten
 * @returns {string} The shortened URL
 * @example
 * stripURL("https://github.com/fossas/fossa") // => "github.com"
 * stripURL("https://www.example.com/path") // => "example.com"
 * stripURL("http://subdomain.example.com") // => "subdomain.example.com"
 */
export function stripURL(url?: string): string {
  if (!url) {
    return '';
  }
  const { hostname } = new URL(url);
  //  Strip the "www." if it exists
  if (hostname.startsWith('www.')) {
    return hostname.slice(4);
  }
  return hostname;
}
